import { Node } from "@tiptap/core";

const DocumentsUsedListNode = Node.create({
  name: "documents-used-list",
  group: "inline",
  inline: true,
  atom: true,

  addAttributes() {
    return {
      qid: {
        default: null,
      },
    };
  },

  parseHTML() {
    return [
      {
        tag: "documents-used-list",
      },
    ];
  },

  renderHTML({ HTMLAttributes }) {
    return ["documents-used-list", HTMLAttributes];
  },

  addNodeView() {
    return ({ node }) => {
      const { qid } = node.attrs;
      const dom = document.createElement("div");

      const style = {
        color: "blue",
        cursor: "pointer",
        border: "1px solid white",
        width: "fit-content",
      };

      Object.assign(dom.style, style);

      dom.innerHTML = `Referenced Documents`;
      dom.onclick = (e) => {
        e.preventDefault();
        e.stopPropagation();
        (window as Window).showDocumentsUsedInQueryAnswer(e, { qid });
      };

      dom.dataset.qid = qid;

      return {
        dom,
      };
    };
  },
});

export default DocumentsUsedListNode;
